import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Condominio = () => {
  const wpp = generateWhatsAppLink('condominio', 'condominio-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Condomínios | Sustenta LED</title>
        <meta name="description" content="LED para condomínios: áreas comuns, garagens e externas. Somos atacadistas e distribuidores com atendimento especializado." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Condomínios</h1>
              <p>Oferecemos iluminação LED para áreas comuns, garagens, jardins e acessos. Somos atacadistas e distribuidores com portfólio completo e suporte técnico para síndicos e administradoras.</p>
              <p>Indicamos modelos com eficiência e longa vida útil, reduzindo custos de manutenção e consumo de energia.</p>
              <p>Solicite cotação e receba condições especiais para condomínios residenciais e comerciais.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_como_trabalhamos.jpg" alt="LED para Condomínios - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Condominio;
